import { render, staticRenderFns } from "./UnlimitedAllowanceTypeInfo.vue?vue&type=template&id=282b620c"
import script from "./UnlimitedAllowanceTypeInfo.vue?vue&type=script&lang=js"
export * from "./UnlimitedAllowanceTypeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports